import {animate, state, style, transition, trigger} from '@angular/animations';
import {Component, Input, OnInit, TemplateRef} from '@angular/core';

@Component({
    selector: 'app-tree-view-node',
    templateUrl: './tree-view-node.component.html',
    styleUrls: ['./tree-view-node.component.scss'],
    animations: [
        trigger('state', [
            state('expanded', style({
                height: '*',
                overflow: 'visible',
                opacity: '1',
            })),
            state('collapsed', style({
                height: '0px',
                overflow: 'hidden',
                opacity: '0',
            })),
            transition('expanded <=> collapsed', [
                animate('200ms ease-in-out')
            ]),
        ]),
    ],
    standalone: false
})
export class TreeViewNodeComponent implements OnInit {

	@Input()
	public data: any;

	@Input()
	public childrenExpression!: string;

	@Input()
	public expandedExpression!: string;

	@Input()
	public level: number = 0;

	@Input()
	public template!: TemplateRef<any>;

	constructor() {}

	ngOnInit(): void {
	}
}
